import React, { useCallback } from 'react'
import { Button, makeStyles } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import clsx from 'clsx'
import { useCurrentTab } from '../../../organisms/AdvisorView/components/AdvisorViewTabs'
import { ADMIN_ROUTES, ICON_NAMES } from '../../../../constants'
import Icon from '../../../atoms/Icon'
import { useCheckPolicy } from '../../../../hooks'
import { ROLES } from '../../../../policies/admin'

const useStyles = makeStyles((theme) => ({
  roundedButton: {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 25,
    padding: '0.45rem 1rem',
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    alignSelf: 'flex-start',
    marginLeft: 'auto',
    '& .MuiButton-label': {
      fontSize: '0.75rem'
    }
  },
  disabled: {
    borderColor: 'rgba(0, 0, 0, 0.12)'
  },
  actions: {
    marginLeft: 'auto',
    display: 'flex',
    gap: '0.5rem'
  }
}))

function HeaderActions () {
  const history = useHistory()
  const classes = useStyles()
  const tabValue = useCurrentTab()
  const canEditRoles = useCheckPolicy(ROLES.editWealthOwnerRoles)

  const onClickNewClient = useCallback(() => {
    history.push(ADMIN_ROUTES.NEW_CLIENT)
  }, [history])

  if (tabValue === 'clients') {
    return (
      <div className={classes.actions}>
        <Button
          color='primary'
          className={classes.roundedButton}
          onClick={onClickNewClient}
          variant='contained'
          startIcon={<Icon customSize='1.2rem' name={ICON_NAMES.add} />}
        >
          Add Client
        </Button>
      </div>
    )
  }

  if (tabValue === 'experiences' && canEditRoles) {
    return (
      <div className={classes.actions}>
        <Button
          color='primary'
          className={clsx(classes.roundedButton)}
          variant='contained'
          onClick={() => history.push(`${ADMIN_ROUTES.WEALTH_OWNERS}/roles/new`)}
          startIcon={<Icon customSize='1rem' name={ICON_NAMES.add} />}
        >
          Add Experience
        </Button>
      </div>
    )
  }

  return null
}

export default HeaderActions
